import LDatepicker from './src/main'

/* istanbul ignore next */
LDatepicker.install = function(Vue) {
  Vue.component(LDatepicker.name, LDatepicker)
}

export default LDatepicker
